import { ArrayInput, Create, Datagrid, Edit, List, NumberInput, Show, SimpleForm, SimpleFormIterator, SimpleShowLayout, TextField, TextInput, useRecordContext } from "react-admin";

export const DaysField = (props) => {
    const record = useRecordContext(props);
    return record ? <span>{record.days.map((d) => { return d.day }).join(",")} </span> : null;
};

export const CalendarDataList = () => (
    <List>
        <Datagrid rowClick="show">
            {/* <TextField source="id" /> */}
            <TextField source="month_raw" label="Month" />
            <DaysField label="Holidays" />
        </Datagrid>
    </List>
);

export const CalendarDataShow = () => (
    <Show>
        <SimpleShowLayout>
            <TextField source="month_raw" />
            <DaysField label="Holidays" />
        </SimpleShowLayout>
    </Show>
);

export const CalendarDataCreate = () => (
    <Create>
        <SimpleForm>
            <TextInput source="month_raw" label="Month (YYYYMM) Ex: Jan 2022 = 202201"  fullWidth="true" />
            <ArrayInput source="days" label="Holidays">
                <SimpleFormIterator>
                    <NumberInput source="day" onWheel={e => e.target.blur()} />
                </SimpleFormIterator>
            </ArrayInput>
        </SimpleForm>
    </Create>
);

export const CalendarDataEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput source="month_raw" label="Month (YYYYMM) Ex: Jan 2022 = 202201" fullWidth="true"/>
            <ArrayInput source="days" label="Holidays">
                <SimpleFormIterator>
                    <NumberInput source="day" onWheel={e => e.target.blur()} />
                </SimpleFormIterator>
            </ArrayInput>

        </SimpleForm>
    </Edit>
);

